import useTableTuneFlag from './useTableTuneFlag'

/**
 * The "show the arrows" button's preference (contract §6.2): key `PlannerDetailsSequenceArrows`, field
 * `SEQUENCE_ARROWS`, `show` = the arrows are visible. Nothing saved (or unreadable): visible (RN36).
 *
 * @param {Object} options
 * @param {Boolean} options.enabled Reads it
 * @returns {[Boolean, Function]} Whether the arrows are visible, and the function that flips it
 */
const useSequenceArrowsPreference = ({ enabled = true } = {}) => (
  useTableTuneFlag({ tableKey: 'PlannerDetailsSequenceArrows', fieldName: 'SEQUENCE_ARROWS', defaultValue: true, enabled })
)

export default useSequenceArrowsPreference
